import styled from 'styled-components';

const StyledContactStepsIndicator = styled.div`
  position: relative;
  padding-right: 64px;
  padding-left: 64px;
  padding-top: 172px;
  .indicator--wrap{
    position: relative;
    width: 41.65%;
    margin-bottom: ${props => props.theme.components_spacing_desk.medium}px;
  }
  .indicator--current{
    position: relative;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
    left: 0;
    background-color: ${props => props.theme.colors.green_secondary};
    transform: translateX(-50%);
    transition: left .25s;
  }
  .indicator--current-hole{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #fff;
  }
  .indicator--bar{
    position: absolute;
    left: 0;
    width: 100%;
    height: 8px;
    background-color: #F2F2F2;
    top: 50%;
    transform: translateY(-50%);
  }
  .indicator--bar-green{
    position: absolute;
    left: 0;
    width: 100%;
    height: 8px;
    background-color: ${props => props.theme.colors.green_secondary};
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    transition: width .25s;
  }
  .indicator--steps{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 2;
  }
  .circle-step{
    width: 24px;
    height: 24px;
    background-color:#CCCCCC;
    border-radius: 50%;
    margin-left: -2px;
    transition: background-color .15s .5s;
    cursor: pointer;
  }
  .circle-step.selected{
    background-color: ${ props => props.theme.colors.green_secondary};
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px;
    
  }
  @media screen and (max-width: 1023px){
    .indicator--wrap{
      width: 66.66%;
      margin-bottom: ${props => props.theme.components_spacing_tablet.medium}px;

    }
  }
  @media screen and (max-width: 767px){
    padding-right: 24px;
    padding-left: 24px;
    .indicator--wrap{
      width: calc(100% - 24px);
      margin-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    }
    .indicator--current{
      width: 32px;
      height: 32px;
    }
    .indicator--current-hole{
      width: 16px;
      height: 16px;
    }
    .circle-step{
      width: 16px;
      height: 16px;
    }
  }
`;

export {
  StyledContactStepsIndicator,
};

